import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
const includes = ['6 Premium Volumes', '5 Exclusive Bonuses', '7-Step Case Decision Framework', 'Clinical Decision Maps', 'Case Worksheets', 'Risk & Control Filters', 'Case Review Audit™', '15-Minute Case Analysis Protocol™', 'Lifetime Access', '7-Day Guarantee'];
export function FinalCta() {
  return <section className="bg-brand-800 px-5 pb-28 pt-16 sm:py-20 text-white" data-id="element-115" data-mp="1eqe9rhtqnn93">
      <div className="mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1irg87wftzva0">
        <h2 className="font-serif text-[32px] leading-tight sm:text-5xl font-extrabold" data-id="element-117" data-mp="14qndbalmay6d">
          Ready to stop asking <em className="text-brand-200" data-id="element-118" data-mp="19of4u3icoia1">“What do I do next?”</em>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[17px] leading-relaxed text-brand-100" data-id="element-119" data-mp="2z4eju18nh1xl">
          You don’t need another giant library of disconnected information. You need a way to organize the information you
          already have.
        </p>
        <ul className="mx-auto mt-8 grid max-w-xl gap-x-6 gap-y-3 text-left sm:grid-cols-2" data-id="element-120" data-mp="27k148fcwiqm">
          {includes.map(i => <li key={i} className="flex items-center gap-2.5 text-[16px] font-semibold" data-id="element-121" data-mp="3tdlggt6ctyi2">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-122" data-mp="b3j8ltyqb04f">
                <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-123" data-mp="71xz8ilel3yz" />
              </span>
              {i}
            </li>)}
        </ul>
        <p className="mt-10 text-sm font-bold uppercase tracking-wider text-brand-200" data-id="element-124" data-mp="3ahvbqy71eo0h">Only</p>
        <p className="font-serif text-7xl sm:text-8xl font-extrabold leading-none" data-id="element-125" data-mp="3oh4h12tpfxpo">$27</p>
        <div className="mt-8" data-id="element-126" data-mp="3jg70svs99dqt">
          <CtaButton label="Get Ortho Decision System™ now" data-id="element-127" data-mp="3jfxaf73at4kl" />
        </div>
        <p className="mt-4 text-sm text-brand-100" data-id="element-128" data-mp="13oswkvpo86he">One-time payment · Instant digital access · Lifetime access · 7-Day Guarantee</p>
        <Countdown tone="dark" data-id="element-129" data-mp="yt3uolq6idhx" />
      </div>
    </section>;
}